export default __webpack_public_path__ + "static/media/my-bg.9c63592e.png";